import { ProductGroupsApiType } from './OrderContainersContext/ProductGroups/useProductGroups'
import { uniqueId } from 'lodash'
import { SupplyOwnerDefinition, SupplyOwnerMap } from '../Panes/ControlPane/PaneComponents/SupplyFilters/types'

export function updateDriverAndScheduleIds(
  supplyOption: Gravitate.SupplyOption,
  driverName: string,
  driverScheduleId: string
) {
  return {
    drops: supplyOption.payload.drops.map((drop) => updateFields(drop, driverName, driverScheduleId)),
    loads: supplyOption.payload.loads.map((load) => updateFields(load, driverName, driverScheduleId)),
    detours: supplyOption.payload.detours?.map((detour) => updateFields(detour, driverName, driverScheduleId)) || [],
  }
}

function updateFields(
  payload: Gravitate.OrderDetour | Gravitate.OrderLoad | Gravitate.OrderDrop,
  driverName: string,
  driverScheduleId: string
) {
  return {
    ...payload,
    ...(payload.detour_id === '' && { temp_id: payload.temp_id || uniqueId() }),
    driver: driverName,
    driver_schedule_id: driverScheduleId,
  }
}

export function useDefaultSupplyOwnerMap(
  orderDestinations: Gravitate.OrderDestinations,
  compartments: Gravitate.Order['compartments'],
  productGroups: ProductGroupsApiType['productGroups'],
  isByProduct: boolean
): SupplyOwnerMap {
  const comps = isByProduct ? Object.values(productGroups).flat() : compartments
  const combos = comps.flatMap((c) =>
    c.targets.map((t) => ({
      location_name: t.location_name,
      supply_owner_id: orderDestinations.find((d) => d.store_number === t.location_name)?.supply_owner_id,
      product: c.product_name,
    }))
  )

  // Remove duplicates by creating unique key for each combination
  const uniqueCombos = Array.from(
    new Map(combos.map((item) => [`${item.location_name}|${item.supply_owner_id}|${item.product}`, item])).values()
  )

  return { definitions: uniqueCombos }
}
